
import { SortParams, paramsDefault } from '@/shared/interfaces/sortParams.model';
import { defineComponent } from 'vue';

import CitiesList from './CitiesList.vue';
import CitiesSearch from './CitiesSearch.vue';

export default defineComponent({
	components: { CitiesList, CitiesSearch },
	name: 'CitiesContainer',

	computed: {
		cities() {
			return this.$store.getters.getCities;
		},
	},

	methods: {
		sortCities(params: SortParams = paramsDefault) {
			this.$store.commit('sortCities', params);
		},

		onSortCities(params: SortParams) {
			this.$store.commit('sortCities', params);
		},

		onFilterCities(phrase: string) {
			this.$store.commit('filterCities', phrase);
		},
	},

	mounted() {
		this.$store.commit('setCities');
	},
});
